import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";

const slides = dramas.filter((d) => d.featured).slice(0, 4);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + slides.length) % slides.length);
  };

  return (
    <section className="relative w-full overflow-hidden" aria-label="焦点轮播">
      <div className="relative h-[440px] w-full md:h-[560px]">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={slide.banner}
              alt={`${slide.title} 剧照`}
              title={`${slide.title} 韩剧剧情介绍`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/10"></div>
          </div>
        ))}

        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-2xl">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-500 text-background-50">
                  编辑力荐
                </span>
                {slides[index].genres.map((g) => (
                  <span key={g} className="rounded-full border border-white/40 px-3 py-1 text-xs text-white/90">
                    {g}
                  </span>
                ))}
              </div>
              <h2 className="mt-4 font-heading text-3xl font-800 text-white md:text-5xl">
                {slides[index].title}
              </h2>
              <p className="mt-4 line-clamp-3 max-w-xl text-sm leading-relaxed text-white/85 md:text-base">
                {slides[index].synopsis[0]}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/drama/${slides[index].id}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-500 text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  <i className="ri-play-fill text-lg"></i>
                  查看剧集详情
                </Link>
                <Link
                  to="/category/drama"
                  className="whitespace-nowrap rounded-md border border-white/50 px-6 py-3 text-sm font-500 text-white transition-colors hover:bg-white/10 cursor-pointer"
                >
                  浏览更多剧集
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={() => go(-1)}
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/20 text-white backdrop-blur transition-colors hover:bg-white/30 md:flex md:left-6 cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/20 text-white backdrop-blur transition-colors hover:bg-white/30 md:flex md:right-6 cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => setIndex(i)}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                i === index ? "w-8 bg-primary-400" : "w-2 bg-white/50"
              }`}
              aria-label={`切换到第${i + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}